<script setup lang="ts">
import type { FormFieldDef, FormPageDef, FormSectionDef } from '@fondationcss/sdk';
import { FormFieldType } from '@fondationcss/sdk';
import { FieldRenderer } from '@fondationcss/forms';

const props = defineProps<{
  page: FormPageDef;
  values: Record<string, unknown>;
  confirmedEmail: string | null;
  showPhone?: boolean;
}>();
const phone = defineModel<string>('phone', { required: true });
const emit = defineEmits<{ 'update-field': [key: string, value: unknown] }>();
const sortedSections = (sections: FormSectionDef[]) => [...sections].sort((a, b) => a.order - b.order);
const sortedRows = (section: FormSectionDef) => [...section.rows].sort((a, b) => a.order - b.order);
const visibleFields = (fields: FormFieldDef[]) => fields.filter(field => !field.hidden && field.type !== FormFieldType.Hidden);
function colWidth(section: FormSectionDef, field: FormFieldDef): number {
  const per = 12 / Math.max(1, section.columnCount);
  return Math.min(12, Math.round(per * Math.max(1, field.colSpan)));
}
</script>

<template>
  <v-card flat>
    <div v-for="section in sortedSections(props.page.sections)" :key="section.id" class="mb-4">
      <div v-if="section.title" class="text-subtitle-1 font-weight-medium mb-2">{{ section.title }}</div>
      <v-row v-for="row in sortedRows(section)" :key="row.id" dense>
        <v-col v-for="field in visibleFields(row.fields)" :key="field.id" :cols="12" :md="colWidth(section, field)">
          <FieldRenderer :field="field" :model-value="props.values[field.key]"
            :readonly="field.key === 'email' && !!props.confirmedEmail"
            @update:model-value="emit('update-field', field.key, $event)" />
        </v-col>
      </v-row>
    </div>
    <div v-if="props.showPhone" class="mt-2">
      <v-divider class="mb-3" />
      <div class="text-subtitle-1 font-weight-medium mb-2">Téléphone mobile (optionnel)</div>
      <v-row dense>
        <v-col cols="12" md="7">
          <v-text-field v-model="phone" label="Numéro de mobile" density="compact" type="tel" autocomplete="tel" />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
